import {Link} from 'react-router-dom'
import { useEffect, useState } from 'react'
import {db} from '../../firebase'
import {collection, getDocs, query, where} from "firebase/firestore"
import '../../Styles/loading.css' 
import "../../Styles/filtro.css";

const Filtro_consulta3  = ({filtro_subcategoria}) => {

    
    const [data3, setData3] = useState([])

    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)


    const getData = async() => {
        try{
            setLoading(true);
            const dataRef = collection(db, "productos");
            const q = query(
                            dataRef,
                            //  where("categoria", "==", 'navidad'),
                             where("subcategoria","==",`${filtro_subcategoria}`)
            );
            //db.collection("Habitaciones").orderBy("fecha_ingreso", "desc").limit(22).onSnapshot((querySnapshot) => 
            //lo de arriba podria usarlo cuando tenga los datos de las fechas de registro
            //para poder poner la data en orden secuencial de los mas nuevos
            const querySnapshot = await getDocs(q)
        
            const dataDB = querySnapshot.docs.map((doc) => doc.data());
            setData3(dataDB);
        } catch (error) {
            console.log(error)
            
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getData();
    }, [])

    if(loading) return <div className='loader'></div>
    if (error) return <p>{error}</p>
    
    return (
        <div className="producto_section">
            {
            data3.length > 0 ? (
                data3.map(item => (
                
                <Link style={{ textDecoration: 'none', color:'inherit'}} to={`producto/${item.id}`}>
                    <div key={item.id} className="producto" > 
                            
                            <div className='img_prod'>    
                                <img 
                                    src={item.imagen}
                                    alt="producto"/>
                            </div>   
                            <div className="titulo_prod">
                            {item.nombre}
                        
                            </div>     
                            <div className='precio_prod'>
                            <p> <b>S/.</b>{item.precio}</p>
                            </div>
                        
                    </div>
                </Link>
                
            ))  
            ):(
            <p> Aun no hay productos</p>
            )
            }
        </div>
    )
}

export default Filtro_consulta3